import { applyCost, canAffordCost } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';
import { queueConstruction } from '../economy/construction';
import { canQueueBuilding } from '../economy/settlementLimits';

export const buildGoldMineAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    if (!canQueueBuilding(settlement, 'goldMine')) return false;
    if (settlement.regionResources.goldDeposit <= 0) return false;
    const cost = state.config.buildings.goldMine.cost || {};
    if (!canAffordCost(settlement, cost)) return false;
    applyCost(settlement, cost);
    queueConstruction(settlement, 'goldMine', state.simulation.tick, cost);
    return true;
};
